import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ClockIcon } from 'lucide-react';
export function PriceAnchor() {
  return <section id="oferta" className="py-10 md:py-20 px-5 md:px-6 bg-[#A9D7E2] text-[#2D1F1A] text-center" data-id="element-136">
      <div className="max-w-3xl mx-auto" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="space-y-5 md:space-y-8" data-id="element-138">
          <div className="space-y-2 md:space-y-3" data-id="element-139">
            <p className="text-xl md:text-3xl text-[#2D1F1A]/50 line-through decoration-red-500 decoration-2 font-light" data-id="element-140">
              Precio Real: $49.99
            </p>
            <h2 className="text-6xl md:text-9xl font-bold text-[#F9A8B7] tracking-tight leading-none drop-shadow-sm" data-id="element-141">
              HOY: $14.99
            </h2>
          </div>
          <div className="inline-flex items-center gap-2 bg-white/70 px-4 py-2 md:px-6 md:py-3 rounded-full text-[#EC8FA1] font-bold italic text-sm md:text-base" data-id="element-142">
            <ClockIcon className="w-4 h-4 md:w-5 md:h-5 animate-pulse not-italic" data-id="element-143" />
            <span data-id="element-144">
              Oferta válida{' '}
              <span className="underline decoration-2 underline-offset-4" data-id="element-145">
                solo por HOY
              </span>
            </span>
          </div>
          <div className="pt-4 md:pt-8" data-id="element-146">
            <Button className="text-xl py-5 px-10 w-full md:w-auto shadow-[0_0_40px_rgba(255,139,107,0.4)]" data-id="element-147">
              QUIERO MIS RECETAS
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}